import { loginEventsQueryKeys as e } from "./useLoginEventsQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { usersApi as n } from "@maat/api-main";
//#region src/profile/useLoginEventsQuery.ts
var r = (r = !0) => t({
	queryKey: e.list(),
	queryFn: n.getLoginEvents,
	enabled: r
});
//#endregion
export { r as useLoginEventsQuery };
